module.exports = __webpack_public_path__ + "img/m_head_more.dcfe08d5.jpg";